import {Provider} from '@oilstone/container';
import Cookie from "@/services/cookie";
import Cookies from 'js-cookie';

export default new Provider().register(container => {
    container.singleton('cookie', () => {
        return new Cookie(Cookies.withAttributes({path: '/', domain: '.' + process.env.VUE_APP_SHARED_SESSION_DOMAIN}));
    });
});
